// prettier-disable-next-line
import {
  addIdToData
} from "@/utils/helpers.js";
import stripIndent from "common-tags/lib/stripIndent";

const info = {
  text: {
    introduction: {
      en: `With thanks to Chanel, your complimentary audio guide for <em>Gabrielle Chanel. Fashion Manifesto</em> narrated by house ambassador, actress Tilda Swinton.`
    },
    sponsor: {
      en: `Major Partner`
    },
    imageCreditsHeading: {
      en: `Image Credits`
    },
    imageCreditsImage: {
      en: require("../assets/images/misc/IntroductionImage.jpg"),
    }
  },
  imageCredits: [{
      image: require("../assets/images/stop-images/stop-1.jpg"),
      text: {
        title: {
          en: stripIndent `
          Gabrielle Chanel in front of her boutique in Deauville, 1913. Photograph &copy; Deauville, private collection<br/>
Photograph &copy; Deauville,	
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-2.jpg"),
      text: {
        title: {
          en: stripIndent `
         Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy

          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-3.jpg"),
      text: {
        title: {
          en: stripIndent `
          Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy

          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-4.jpg"),
      text: {
        title: {
          en: stripIndent `
          Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-5.jpg"),
      text: {
        title: {
          en: stripIndent `
            Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-6.jpg"),
      text: {
        title: {
          en: stripIndent `
          Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy

          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-7.jpg"),
      text: {
        title: {
          en: stripIndent `
          'Coco' Chanel at the Ritz Hotel wearing a ruffled dress, sitting in front of her folding Coromandel screen (drawings by Christian B&eacute;rard and Jean Cocteau), 1937, photograph by Fran&ccedil;ois Kollar. Charenton-le-Pont, M&eacute;diath&egrave;que de l'Architecture et du Patrimoine. &copy; Jean Cocteau / ADAGP. Copyright Agency, 2021. &copy; RMN &ndash; Copyright management Fran&ccedil;ois Kollar. Photo &copy; Minist&egrave;re de la Culture &ndash; M&eacute;diath&egrave;que de l'architecture et du patrimoine, Dist. RMN-Grand Palais / Fran&ccedil;ois Kollar<br/>
&copy; RMN &ndash; Copyright management Fran&ccedil;ois Kollar. Photo &copy; Minist&egrave;re de la Culture &ndash; M&eacute;diath&egrave;que de l'architecture et du patrimoine, Dist. RMN-Grand Palais / Fran&ccedil;ois Kollar				</td> 
				
`
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-8.jpg"),
      text: {
        title: {
          en: stripIndent `
          Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-9.jpg"),
      text: {
        title: {
          en: stripIndent `
         Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-10.jpg"),
      text: {
        title: {
          en: stripIndent `
          Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
      Photo: Sean Fennessy
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-11.jpg"),
      text: {
        title: {
          en: stripIndent `
          Gabrielle Chanel at the Tuileries Garden, Paris, June 1957, photograph by Willy Rizzo. Permanently exhibited at Studio Willy Rizzo. © Willy Rizzo

          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-12.jpg"),
      text: {
        title: {
          en: stripIndent `
         Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-13.jpg"),
      text: {
        title: {
          en: stripIndent `
           1961 Keystone-France
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-14.jpg"),
      text: {
        title: {
          en: stripIndent `
          Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-15.jpg"),
      text: {
        title: {
          en: stripIndent `
          Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-16.jpg"),
      text: {
        title: {
          en: stripIndent `
         Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy
          `
        }
      },
    },
    {
      image: require("../assets/images/stop-images/stop-17.jpg"),
      text: {
        title: {
          en: stripIndent `
          Installation view of <em>Gabrielle Chanel. Fashion Manifesto</em> from 4 December 2021 to 25 April 2022 at NGV International, Melbourne. <br>
Photo: Sean Fennessy
          `
        }
      },
    }
  ]
};

export default addIdToData(info);